import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs';
import { AuthState } from '../store/reducers/auth.reducer';
import { getUserParameterTypes } from '../store/selectors/auth.selector';

/**
 * This is a guard that checks if the user has access to the
 * route based on the route source type (air, water-discharge, etc.)
 */
export const parameterTypeGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authStore = inject<Store<AuthState>>(Store);
  return authStore.select(getUserParameterTypes).pipe(
    filter((parameterTypes) => parameterTypes.length > 0),
    map((parameterTypes) => {
      return parameterTypes.includes(route.data['parameterType']);
    }),
  );
};
